import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ApiTokboxNetworkTestService } from '../../api/apiTokbox/apiTokboxNetworkTest.service';
import { HeaderService } from '../../services/header/header.service';
import { VIDEOCONFERENCE_CONSTANTS } from '../../constants/videoconference.constants';
import { ROUTES_CONSTANTS } from '../../constants/routes.constants';
import { TooltipSupportService } from '../../services/tooltip-support/tooltip-support.service';
import { StateHandlerService } from '../../services/state-handler/state-handler.service';
import { SessionStorageService } from '../../services/session-storage/session-storage.service';
import { EnvironmentService } from '../../services/enviroment/environment.service';
import { UtilsService } from '../../services/utils/utils.service';
import { SupportTooltipComponent } from '../../components/support-tooltip/support-tooltip.component';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { NgClass, NgStyle } from '@angular/common';
import { environment } from '../../../environments/environment';

@Component({
  standalone: true,
  imports: [
    SupportTooltipComponent,
    TranslatePipe,
    TranslateDirective,
    NgStyle,
    NgClass
  ],
  selector: 'sas-network-test',
  templateUrl: './network-test.component.html',
  styleUrls: ['./network-test.component.scss']
})
export class NetworkTestComponent implements OnInit {

  levelWidth = 0;
  audioTestObject = new Audio();
  audioQuestion = false;
  audioStartTest = false;
  audioOutputTest = false;
  audioTest?: boolean;
  videoTest?: boolean;
  networkTest?: boolean;
  mutuaNetworkTestVersion?: boolean;
  devicesTestActivate?: boolean;
  showConnectivityTestResults = true;

  /**
   * support phone
   */
  hide: boolean = true;
  supportPhone: string;

  /**
   * Método que abre el supportNumberTooltip.
   */
  public showSupportNumber() {
    this.tooltipSupportService.setCloseOpenTooltipSupport(true);
  }

  constructor(
    private readonly stateHandlerSrv: StateHandlerService,
    private readonly sessionStoregeSrv: SessionStorageService,
    private readonly enviroment: EnvironmentService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly router: Router,
    private readonly opentokNetworkTestSrv: ApiTokboxNetworkTestService,
    private readonly utilsService: UtilsService,
    private readonly headerSvc: HeaderService,
    private readonly tooltipSupportService: TooltipSupportService,
    private readonly cdr: ChangeDetectorRef
  ) {
    this.supportPhone = this.enviroment.data.tech_support_phone;
  }

  ngOnInit(): void {
    this.devicesTestActivate  = this.enviroment.data?.features?.audio_test && this.enviroment.data?.features?.network_test;
    this.mutuaNetworkTestVersion = this.enviroment.data?.features?.network_test_style === this.enviroment.data?.appClientName;
    this.devicesTestActivate ? ( this.mutuaNetworkTestVersion ? this.navigationToCustomNetworkTest() : this.getMedia() ) : this.navigateToRoom();
  }

  getMedia() {
    this.sessionStoregeSrv.clear();
    const intervalId = this.meterLevelGenerator();
    const attendantId = this.activatedRoute.snapshot.queryParams[VIDEOCONFERENCE_CONSTANTS.URL_PARAM_ATTENDANT];

    this.opentokNetworkTestSrv.getNetWorkTestCredentials(environment.isPatient?attendantId:undefined);
    this.stateHandlerSrv.get('connectivity_test').subscribe( (data:any) => {
      console.log('DefaultNT stateHandlerSrv connectivity_test (' + this.utilsService.getTodayWithHour() + ')', data);
      if (data) {
        clearInterval(intervalId);
        this.levelWidth = 100;
        this.setConnectivityTestResults(data);
      }
    });

    // let stream2 = null;
    // try {
    //   stream2 = await navigator.mediaDevices.getUserMedia({ video: { facingMode: { exact: 'environment' } } });
    //   console.log(stream2);
    // } catch (err) {
    //   console.log(err);
    // }
  }

  meterLevelGenerator(): any {
    const totalDuration = this.opentokNetworkTestSrv.TEST_DURATION;
    const intervalDuration = 100 / totalDuration;

    const intervalId = setInterval( () => {
      if (this.levelWidth <= 100) {
        this.levelWidth = this.levelWidth + intervalDuration;
      } else {
        this.levelWidth = 100;
        clearInterval(intervalId);
      }
      this.cdr.detectChanges();
    }, intervalDuration);

    return intervalId;
  }

  playAudio() {
    this.audioStartTest = false;
    if (!this.audioOutputTest) {
      this.audioTestObject.src = this.enviroment.data?.features?.speakerTest?.url;
      this.audioTestObject.play();
      this.audioQuestion = true;
    }
  }

  audioTestOk() {
    this.audioTestObject.pause();
    this.audioTestObject.remove();
    this.audioTestObject = new Audio();
    this.audioQuestion = false;
    this.audioOutputTest = true;
    this.testResults();
  }

  audioTestKo() {
    this.audioTestObject.pause();
    this.audioQuestion = false;
  }

  setConnectivityTestResults(results:any) {
    this.audioTest = results?.audio?.supported;
    this.videoTest = results?.video?.supported;
    this.networkTest = this.audioTest && this.videoTest;
    this.testResults();
  }

  testResults() {
    this.showConnectivityTestResults = false;
    if (this.devicesTestActivate && this.networkTest) {
      this.audioQuestion = true;
      this.audioStartTest = true;
      this.audioOutputTest && this.navigateToRoom();
    }
  }

  private getQueryParams(isConnected = false): NavigationExtras {
    const attendantId = this.activatedRoute.snapshot.queryParams[VIDEOCONFERENCE_CONSTANTS.URL_PARAM_ATTENDANT];
    const pin = this.activatedRoute.snapshot.queryParams[VIDEOCONFERENCE_CONSTANTS.URL_PARAM_PIN];

    const queryParams = this.enviroment.data?.features?.pin_required && pin
          ? { 'access': attendantId, pin }
          : { 'access': attendantId };

    return {
      queryParams: queryParams,
      replaceUrl: true
    };
  }

  private navigateToRoom() {
    this.router.navigate([ROUTES_CONSTANTS.ROOM.path], this.getQueryParams());
  }

  private navigationToCustomNetworkTest() {
    if(environment.isPatient){
      var urlPin = this.sessionStoregeSrv.get('s');
      this.sessionStoregeSrv.clear();
      this.sessionStoregeSrv.set('s', urlPin);
    }else{
      this.sessionStoregeSrv.clear();
    }
    
    this.router.navigate([ROUTES_CONSTANTS.MUTUA_NETWORK_TEST.path], this.getQueryParams());
  }

}
